module.exports = __webpack_public_path__ + "img/erCode.d08f99df.png";